// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
  // apiKey: 'http://10.10.143.68:94/api/'
  
  apiKey: 'https://logixspire-002-site15.ctempurl.com/api/'
  // apiKey: "http://localhost:5145/api/"

  // apiKey: "https://api.prpotepatilengg.ac.in/api/"
  // apiKey:'https://maash2020-001-site2.htempurl.com/api/'
  // apiKey: 'http://testapi.prpotepatilengg.ac.in/api/'
  // apiKey:"http://localhost:99/api/"
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
